import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge Tailwind class names safely: clsx handles conditionals,
 * tailwind-merge resolves conflicts (e.g. `p-2` overriding `p-4`).
 * This is the standard shadcn/ui-style helper adapted for @hauraki/ui.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
